import SvgRender from 'common/components/general/SvgRender';
import spinner from 'common/assets/svg/common/spinner.svg';

const Spinner = ({ size, style, ...rest }) => (
  <SvgRender src={spinner} style={{ width: size, height: size, ...style }} {...rest} />
);
Spinner.defaultProps = {
  size: 32
};

export default Spinner;
